import './index.scss'

export default function BaseTitle({ children, className = '', ...props }) {
  return (
    <div className={`BaseTitle ${className}`.trim()} {...props}>
      {children}
    </div>
  )
}
